import React from 'react';
import { useTranslation } from 'react-i18next';
import SectionHeader from '../shared/SectionHeader';
import '../../styles/landing/TrustSecuritySection.css';

const TrustSecuritySection: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section
            id="security"
            className="landing-section landing-section--blush"
            aria-labelledby="security-heading"
        >
            <div className="landing-container">
                <div className="trust-security landing-card">
                    <div className="trust-security__icon" aria-hidden="true" />
                    <SectionHeader title={t('security.title')} id="security-heading" />
                    <p className="trust-security__body">{t('security.body')}</p>
                </div>
            </div>
        </section>
    );
};

export default TrustSecuritySection;
